import { MuiComponentOverrides } from "."
import spacing from "theme/themeSpacing"

export const MuiAccordionDetailsOverrides: MuiComponentOverrides<'MuiAccordionDetails', 'MuiAccordionDetails'> = {
  styleOverrides: {
    root: {
      padding: `0 0 ${spacing.md}`,
    }
  }
}
